// removed by extract-text-webpack-plugin
module.exports = {"PendingStores_table":"PendingStores__PendingStores_table___10y9O","PendingStores_panelBody":"PendingStores__PendingStores_panelBody___1tVy5","PendingStores_tdNumbers":"PendingStores__PendingStores_tdNumbers___3IDL-","PendingStores_thAddress":"PendingStores__PendingStores_thAddress___1QrUl","PendingStores_thCeco":"PendingStores__PendingStores_thCeco___2jTHb"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/stockStoreUpdate/components/PendingStores.css
// module id = 1069
// module chunks = 0